import _ from 'lodash';

export { default as prefix } from './prefix';

export const isNotEmpty = _.negate(_.isEmpty);

export const upperCap = str => _.upperFirst(_.camelCase(str));

export function saveCSV(content, fileName?: string) {
  const blob = new Blob([content], {
    type: 'application/octet-stream',
  });
  const objectUrl = URL.createObjectURL(blob);
  const aLink = document.createElement('a');
  aLink.href = objectUrl;
  aLink.download = fileName;
  aLink.click();
  URL.revokeObjectURL(objectUrl);
}

export function converDate() {
  const date = new Date();
  const nowMonth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const nowDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const nowHours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const nowMinutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const nowSeconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
  return `${date.getFullYear()}${nowMonth}${nowDate}${nowHours}${nowMinutes}${nowSeconds}`;
}

export function postMessage(params = {}) {
  window.parent.postMessage(params, '*');
}

export function convertBrand(name: any) {
  if (name === 'brandshiseido') {
    return 'bS';
  } else if (name === 'IPSA CDP') {
    return 'IPSA';
  } else {
    return name;
  }
}

export function downloadTemplate(url: string, fileName: string) {
  const aLink = document.createElement('a');
  aLink.href = url;
  aLink.download = fileName;
  aLink.click();
}
/**
 * 格式化搜索参数
 * 返回 filterColumn search
 */
export function fmtSearchParams(params, omits: string[] = []) {
  let filterColumn = null,
    search = null;
  omits.forEach((item) => {
    if (params[item]) {
      filterColumn = item;
      search = params[item];
      return;
    }
  });
  const data = {
    ..._.omit(params, omits),
    filterColumn,
    search,
  };
  return data;
}
